import type { FC } from 'react';

import { useAllUserList } from 'hooks/useAllUserList';

import { counterLabel } from '../const';
import styles from './styles.module.scss';

const Count: FC = () => {
    const { list } = useAllUserList();

    return (
        <div className={styles.wrapper}>
            {counterLabel} <span className={styles.counter}>{list.length}</span>
        </div>
    );
};

export default Count;
